module.exports = __webpack_public_path__ + "static/2-3bc520b6303111dabbe675d9761909d8.png";